module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_344762.849a5a75.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_344762.pdf
// module id = 322
// module chunks = 0